import { render, staticRenderFns } from "./InvestmentOrders.vue?vue&type=template&id=2a31b830&scoped=true"
import script from "./InvestmentOrders.vue?vue&type=script&lang=js"
export * from "./InvestmentOrders.vue?vue&type=script&lang=js"
import style0 from "./InvestmentOrders.vue?vue&type=style&index=0&id=2a31b830&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a31b830",
  null
  
)

export default component.exports